import React from 'react';
import './country-item.scss';
import getCountryFlag from '../../../../../utils/countries-flags';

const CountryItem: React.FC<{ data: any }> = ({ data }) => {
    const Flag = getCountryFlag(data.countryCode);
    return <span className={'entity-name country-item'}>
         {Flag &&
             <span className={'country-flag'}>
                 <Flag/>
             </span>}
        {data.countryName}
          </span>;
};

export default CountryItem;